var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineBagTimer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.25 15c0-2.62 2.13-4.75 4.75-4.75s4.75 2.13 4.75 4.75-2.13 4.75-4.75 4.75S7.25 17.62 7.25 15zm1.5 0c0 1.79 1.46 3.25 3.25 3.25s3.25-1.46 3.25-3.25-1.46-3.25-3.25-3.25S8.75 13.21 8.75 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.36 16.39c-.21-.36-.1-.82.26-1.03l.76-.46c.08-.05.12-.13.12-.21v-.93c0-.41.34-.75.75-.75s.75.33.75.74v.93c0 .61-.33 1.19-.85 1.5l-.77.46c-.11.08-.25.11-.38.11-.25 0-.5-.13-.64-.36z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 22.75c-4.62 0-5.48-2.15-5.7-4.24l-.75-5.99c-.11-1.08-.15-2.63.9-3.79.9-1 2.39-1.48 4.55-1.48h8c2.17 0 3.66.49 4.55 1.48 1.04 1.16 1.01 2.71.9 3.77l-.75 6.01c-.22 2.09-1.08 4.24-5.7 4.24H9zM4.56 9.74c-.49.54-.65 1.37-.52 2.61l.75 5.99c.17 1.6.61 2.92 4.21 2.92h6c3.6 0 4.04-1.31 4.21-2.9l.75-6.01c.13-1.22-.03-2.05-.52-2.6-.59-.67-1.75-1-3.44-1H8c-1.69 0-2.85.33-3.44.99z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75 7.88V6.5c0-1.05-.45-2.07-1.23-2.78a3.723 3.723 0 0 0-2.89-.95c-1.8.17-3.38 2.01-3.38 3.93v.97c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-.98c0-2.69 2.17-5.17 4.74-5.42 1.5-.14 2.94.33 4.04 1.34a5.27 5.27 0 0 1 1.72 3.89v1.38c0 .41-.34.75-.75.75s-.75-.34-.75-.75z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineBagTimer);
export default __webpack_public_path__ + "static/media/vuesax-outline-bag-timer.560503c35d73e6e2e3a1de915f9d7548.svg";
export { ForwardRef as ReactComponent };